import type { DdosStatus } from '@shared/all/domains/ddosMode';
import { useSyncExternalStore } from 'react';
import { getDdosStatus, getServerDdosStatus, subscribeDdosStatus } from '../helpers/ddosStatus';

/**
 * What the server last said about DDoS mode for this caller. Kept apart from
 * the store it reads (helpers/ddosStatus.ts), which server components reach
 * through the tRPC client and so must stay free of React.
 */
const useDdosStatus = () => {
  return useSyncExternalStore(subscribeDdosStatus, getDdosStatus, getServerDdosStatus);
};
export default useDdosStatus;